import React, {ReactNode} from 'react';

import {Trans} from '../../libs/shared/core/src/helpers/internationalization/react';
import {
  TeammateAccountStatusesEnum,
  TeammateModel,
} from '../../libs/shared/core/src/models/api/teammateModel';
import {buildTeammateDisplayName} from '../../libs/shared/core/src/models/helpers/teammateModelHelpers';

export const accountStatusLabels: Readonly<{[key in TeammateAccountStatusesEnum]: ReactNode}> = {
  [TeammateAccountStatusesEnum.ACTIVE]: <Trans id="teammate-accountstatus-active">Active</Trans>,
  [TeammateAccountStatusesEnum.PENDING]: <Trans id="teammate-accountstatus-pending">Pending</Trans>,
  [TeammateAccountStatusesEnum.PENDING_EMAIL]: (
    <Trans id="teammate-accountstatus-pendingemail">Pending email</Trans>
  ),
  [TeammateAccountStatusesEnum.BLOCKED]: <Trans id="teammate-accountstatus-blocked">Blocked</Trans>,
  [TeammateAccountStatusesEnum.DELETED]: <Trans id="teammate-accountstatus-deleted">Deleted</Trans>,
};

/* Render the name of a teammate, or 'you' if this teammate is the current user.  */
export function renderTeammateNameOrYou(
  userId: number,
  teammate: TeammateModel,
  shouldCapitalizeYou: boolean = false,
) {
  const displayName = buildTeammateDisplayName(teammate);

  if (userId !== teammate.id) {
    return <>{displayName}</>;
  }

  return shouldCapitalizeYou ? (
    <Trans id="teammate-you-capitalize">You</Trans>
  ) : (
    <Trans id="teammate-you">you</Trans>
  );
}
